import MindElementNodeDeserialize from "../../core/core/dataformat/MindElementNodeDeserialize";
import Colors from "../../utils/Colors";
import PlayType from "../datatype/PlayType";
import PlayBackground from "./PlayBackground";

class PlaySettingData {
    constructor() {
        this.playType = PlayType.AnimationReview
        this.playBackground = new PlayBackground("mind_background_1000", "center", Colors.white, Colors.black80, Colors.black50, 0x0C0C0C, 0xF79833, 1000, 1000)
        this.mapScale = 100.0
        this.speed = 0.5;
        this.textSpeed = 0.2;
        this.playOrderList = new Array()
        this.playOrderPeer = false
        this.onlyPlayText = false
        this.playSpeek = true
    }

    getContentJson() {        
        let json = JSON.stringify(this, function (key, val) {
            if (typeof val === "function") {
                return val + '';
            }
            return val
        });
        return json;
    }

    format(json) {
        let playSettingData = new PlaySettingData()
        let data = JSON.parse(json)
        
        for (var key in data) {
            let keyValue = data[key]
            if (key == "playBackground") {
                let playBackground = new PlayBackground()
                let settingDataValue = keyValue
                for (var keyDataValueKey in settingDataValue) {
                    playBackground[keyDataValueKey] = settingDataValue[keyDataValueKey]
                }
                playSettingData.playBackground = playBackground
            } else if (key == "playOrderList") {
                let list = []
                let childSize = keyValue.length
                for (let index = 0; index < childSize; index++) {
                    list.push(this.deserializationLineMindTypeNode(keyValue[index]))
                }
                playSettingData.playOrderList = list
            } else {
                playSettingData[key] = keyValue
            }
        }
        return playSettingData
    }

    deserializationLineMindTypeNode(nodeValue) {
        return MindElementNodeDeserialize.deserialize(nodeValue);
    }
}

export default PlaySettingData